// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html, html > body, div#app {\r\n    height: 100% !important;\r\n}", "",{"version":3,"sources":["webpack://./src/css/globalStyles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B","sourcesContent":["html, html > body, div#app {\r\n    height: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": "app"
};
export default ___CSS_LOADER_EXPORT___;
